import { GoogleOutlined } from '@ant-design/icons'
import { ProviderHelperClient } from '~/plugins/data-connector/helpers/provider.helper.client'
import { ProviderAuthenticationClient } from '../../../authentication/client'
import { ProviderClient } from '../../abstract/provider.client'
import { ProviderGoogleDriveCommon } from '../common'
import { GooglePickerPopup } from './components/GooglePickerPopup'

const authentication = ProviderAuthenticationClient.Oauth2({
  ...ProviderGoogleDriveCommon.authentication,
  clientId: ProviderHelperClient.getEnvVariable('google', 'CLIENT_ID'),
})

export const ProviderGoogleDriveClient: ProviderClient = {
  key: ProviderGoogleDriveCommon.key,
  authentication,
  description: {
    label: 'Google Drive',
    icon: <GoogleOutlined />,
    triggers: [],
    actions: [
      {
        key: 'findManyFiles',
        label: 'Find many files in a folder',
        input: [
          {
            key: 'folderId',
          },
        ],
        output: [
          {
            key: 'files',
          },
        ],
      },
    ],
  },
}

export const ProviderGooglePickerPopup = GooglePickerPopup
